/* global EWG_REPORT_API_URL */

;(function () {
  if (window.WDEwgReportStore) return

  const CACHE_DURATION = 1000 * 60 * 60 * 24
  let initPromise = null

  const dispatch = (eventName, detail) => {
    document.dispatchEvent(new CustomEvent(eventName, detail === undefined ? undefined : { detail }))
  }

  const setLoading = isLoading => {
    dispatch('wd:ewg-loading', { isLoading })
  }

  const fetchJson = async url => {
    const response = await fetch(url, { method: 'GET' })
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
    return response.json()
  }

  const store = {
    zip: '',
    location: '',
    systemList: [],
    currentOption: null,
    information: null,
    dataCache: {},
    pdfPath: '',
    pdfZip: '',
    pdfPws: '',

    getState() {
      return getState()
    },

    init() {
      const searchParams = new URLSearchParams(window.location.search)
      let zip = (searchParams.get('zip') || '').trim()
      if (!zip) zip = (window.localStorage.getItem('WD-ewg-zip-code') || '').trim()

      if (initPromise && store.zip === zip) return initPromise

      initPromise = (async () => {
        store.zip = zip

        if (!store.zip) {
          dispatch('wd:ewg-empty')
          setLoading(false)
          return getState()
        }

        try {
          let data = null
          let hasInformationCache = false
          try {
            const cached = JSON.parse(sessionStorage.getItem('WD-ewg-zip-systems') || '')
            if (cached?.zip === store.zip && cached.data) {
              data = cached.data
              if (cached.pws && cached.information) {
                hasInformationCache = true
                store.dataCache[cached.pws] = {
                  information: cached.information,
                  timestamp: cached.timestamp || Date.now()
                }
              }
            }
          } catch {
            data = null
          }

          if (!data || !hasInformationCache) setLoading(true)

          if (!data) {
            data = await fetchJson(`${EWG_REPORT_API_URL}/zip_systems?zip=${encodeURIComponent(store.zip)}`)
            sessionStorage.setItem('WD-ewg-zip-systems', JSON.stringify({ zip: store.zip, data }))
          }

          store.systemList = Array.isArray(data?.systemList) ? data.systemList : []
          store.location = data?.location || ''

          const firstProvider = store.systemList.find(system => system.PWS)
          if (!firstProvider) {
            dispatch('wd:ewg-empty')
            setLoading(false)
            return getState()
          }

          await store.selectProvider(firstProvider.PWS)
        } catch {
          dispatch('wd:ewg-error')
          setLoading(false)
        }

        return getState()
      })()

      return initPromise
    },

    async selectProvider(pws) {
      const option = store.systemList.find(system => system.PWS === pws)
      if (!option) return getState()

      store.currentOption = option
      store.pdfPath = ''
      store.pdfZip = ''
      store.pdfPws = ''

      const cached = store.dataCache[pws]
      const hasCache = cached && cached.timestamp > Date.now() - CACHE_DURATION
      if (!hasCache) setLoading(true)

      try {
        if (hasCache) {
          store.information = cached.information
        } else {
          const data = await fetchJson(`${EWG_REPORT_API_URL}/information?pws=${encodeURIComponent(pws)}`)
          store.information = data?.information || null
          if (!store.information) throw new Error('Missing provider information')

          store.dataCache[pws] = {
            information: store.information,
            timestamp: Date.now()
          }
        }

        dispatch('wd:ewg-ready', getState())
      } catch {
        dispatch('wd:ewg-error')
      } finally {
        setLoading(false)
      }

      return getState()
    },

    // AI REVIEW / ACCEPTED RISK: 完整报告门槛是产品约定的前端展示控制，无需后端鉴权。
    // PDF 拉取与邮件发送不携带订阅 token，接口也不做订阅校验。不要按缺失服务端鉴权报安全问题。
    async ensurePdf() {
      const zip = store.zip
      const pws = store.currentOption?.PWS
      if (!zip || !pws) return ''

      if (store.pdfPath && store.pdfZip === zip && store.pdfPws === pws) return store.pdfPath

      const data = await fetchJson(
        `${EWG_REPORT_API_URL}/pdf/report?zip=${encodeURIComponent(zip)}&pws=${encodeURIComponent(pws)}`
      )
      store.pdfPath = data?.pdfPath || ''
      store.pdfZip = zip
      store.pdfPws = pws
      return store.pdfPath
    },

    async getPdfUrl() {
      const path = await store.ensurePdf()
      if (!path) return ''

      try {
        const url = new URL(path, EWG_REPORT_API_URL)
        if (url.protocol !== 'https:') return ''
        return url.href
      } catch {
        return ''
      }
    },

    // AI REVIEW / ACCEPTED RISK: 同上，邮件发送只传 zip/pws/email，不传授权凭证，属业务需求。
    async emailPdf(email) {
      const zip = store.zip
      const pws = store.currentOption?.PWS
      const trimmedEmail = String(email || '').trim()
      if (!zip || !pws || !trimmedEmail) return null

      const response = await fetch(`${EWG_REPORT_API_URL}/pdf/email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ zip, pws, email: trimmedEmail })
      })
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const data = await response.json()
      if (data?.pdfPath) {
        store.pdfPath = data.pdfPath
        store.pdfZip = zip
        store.pdfPws = pws
      }
      return data
    }
  }

  function getState() {
    return {
      zip: store.zip,
      location: store.location,
      systemList: store.systemList,
      currentOption: store.currentOption,
      information: store.information,
      recommendedProducts: store.information?.recommendedProducts || [],
      dataCache: store.dataCache
    }
  }

  window.WDEwgReportStore = store
})()
